import React from "react";

export default function PrivateRoom() {
  return <div>Private Room</div>;
}
